export default __webpack_public_path__ + "static/media/complete.5f25ccb2.svg";